import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    places: (count: number) => translate({ id: 'global.counter.places', values: { count } }),
    multipleValues: translate({ id: 'global.multipleValues' }),
  }))

  return api
}
